// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"47830":"321a1ec594190956","65447":"6fa6d54b551ce5e0","68696":"02cc6d559d0b225d","83788":"35d4e883afb76743","98070":"35d4e883afb76743"}[chunkId] + ".css";
};